import { useContext } from "react";
import { Alert, Box } from "@mui/material";

import { isAdminEmail } from "@thalamos/aspire-common";

import { LoggedInUserContext } from "../../Contexts.js";
import { NetworkMapView } from "./NetworkMapView.js";

/**
 * Connectivity Network Map — a distinct, chromeless full-bleed workspace opened
 * in its own window from the Thalamos admin area (App.tsx routes it OUTSIDE the
 * usual <Layout>). It reuses the aspire session cookie (same origin), so auth is
 * transparent, and reads the connectivity graph from `GET /api/connectivity`.
 *
 * Access is internal-only for now: the isAdminEmail (@thalamos.co.uk) gate here
 * is cosmetic — the aspire-server endpoint is the real enforcement (403). Both
 * swap for a trust-level RBAC permission later.
 */
export function NetworkMapWorkspace() {
  const userContext = useContext(LoggedInUserContext);
  const email = userContext?.user?.email;
  const authorised = email !== undefined && isAdminEmail(email);

  if (!authorised) {
    return (
      <Alert severity="error" sx={{ m: 3 }}>
        The connectivity map is restricted to Thalamos staff.
      </Alert>
    );
  }

  // The map lays itself out to the full viewport; fix the container to it.
  return (
    <Box sx={{ position: "fixed", inset: 0 }}>
      <NetworkMapView />
    </Box>
  );
}
